// Structured learning paths guide readers from beginner to advanced.
export const LEARNING_PATHS = [
  {
    slug: "commercial-electricity-fundamentals",
    title: "Commercial Electricity Fundamentals",
    level: "Beginner → Intermediate",
    icon: "Zap",
    color: "#0052FF",
    summary:
      "Start from the basics of how energy markets work and build up to running a smart electricity procurement strategy for your business.",
    articles: [
      "what-is-energy-deregulation",
      "utility-vs-energy-supplier",
      "understanding-commercial-utility-bills",
      "understanding-demand-charges",
      "commercial-electricity-procurement-explained",
      "commercial-electricity-buying-strategies",
    ],
  },
  {
    slug: "commercial-natural-gas-fundamentals",
    title: "Commercial Natural Gas Fundamentals",
    level: "Beginner → Intermediate",
    icon: "Flame",
    color: "#00C853",
    summary:
      "Understand how commercial natural gas is bought and priced, then learn the strategies that manage seasonal volatility.",
    articles: [
      "what-is-energy-deregulation",
      "understanding-commercial-utility-bills",
      "commercial-natural-gas-procurement-explained",
      "commercial-natural-gas-buying-strategies",
    ],
  },
  {
    slug: "understanding-commercial-utility-bills",
    title: "Understanding Commercial Utility Bills",
    level: "Beginner",
    icon: "ReceiptText",
    color: "#0052FF",
    summary:
      "Decode every major component of a commercial energy bill — energy, demand, capacity, and load factor.",
    articles: [
      "understanding-commercial-utility-bills",
      "understanding-demand-charges",
      "understanding-capacity-charges",
      "understanding-load-factor",
    ],
  },
  {
    slug: "commercial-energy-procurement",
    title: "Commercial Energy Procurement",
    level: "Intermediate",
    icon: "Handshake",
    color: "#0052FF",
    summary:
      "Master the procurement discipline: deregulation, pricing models, contracts, and how to buy both electricity and gas strategically.",
    articles: [
      "what-is-energy-deregulation",
      "fixed-vs-indexed-pricing",
      "commercial-energy-contracts-explained",
      "commercial-electricity-procurement-explained",
      "commercial-natural-gas-procurement-explained",
    ],
  },
  {
    slug: "battery-hosting-fundamentals",
    title: "Battery Hosting Fundamentals",
    level: "Beginner",
    icon: "BatteryCharging",
    color: "#06B6D4",
    summary:
      "Learn how grid-scale battery storage works and how landowners in Texas and Illinois can evaluate a hosting opportunity.",
    articles: [
      "what-is-energy-deregulation",
      "understanding-commercial-energy-markets",
      "commercial-battery-hosting-explained",
    ],
  },
  {
    slug: "commercial-energy-markets",
    title: "Commercial Energy Markets",
    level: "Intermediate → Advanced",
    icon: "LineChart",
    color: "#00C853",
    summary:
      "Go deeper on the market forces — grid operators, capacity, and price drivers — that determine what commercial buyers pay.",
    articles: [
      "what-is-energy-deregulation",
      "understanding-commercial-energy-markets",
      "understanding-capacity-charges",
      "fixed-vs-indexed-pricing",
    ],
  },
];
